import * as React from "react";
import { Context } from "./_context";
export const NavigationFavoriteActiveIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.306 1.568a1.375 1.375 0 0 0-2.572-.103l-.04.103-2.167 6.556-6.556.14a1.375 1.375 0 0 0-.828 2.45l5.28 4.21-1.925 6.696a1.375 1.375 0 0 0 2.134 1.49L12 19.181l5.368 3.927a1.376 1.376 0 0 0 2.134-1.489l-1.927-6.695 5.283-4.21a1.375 1.375 0 0 0-.829-2.45l-6.557-.141-2.166-6.556Z", fill: "currentColor" }));
  return iconset[size];
};
NavigationFavoriteActiveIcon.iconId = "BkOJjI";
